import { useEffect, useState } from "react";
import useCampaignsService from "../../services/CampaignsService";
import { Reward } from "../../types/Campaigns";
import PositiveButton from "../PositiveButton";
import { useNavigate } from "react-router-dom";

interface CampaignRewardsListProps {
  campaignId: string;
}

export default function CampaignRewardsList({
  campaignId,
}: CampaignRewardsListProps) {
  const [rewards, setRewards] = useState<Reward[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { getRewardsForCampaign } = useCampaignsService();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRewards = async () => {
      setIsLoading(true);
      try {
        const rewardsData = await getRewardsForCampaign(campaignId);
        setRewards(rewardsData as Reward[]);
      } catch (error) {
        console.error("Error fetching rewards:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRewards();
  }, [campaignId, getRewardsForCampaign]);

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="flex justify-between items-center">
        <h3>Campaign Rewards</h3>
        <div className="flex justify-end">
          <PositiveButton
            disabled={isLoading}
            className="btn btn-primary"
            onClick={() => {
              // Navigate to create reward page
              navigate(`/admin/campaigns/${campaignId}/rewards/new`);
            }}
          >
            Create New Reward
          </PositiveButton>
        </div>
      </div>
      {isLoading ? (
        <p>Loading rewards...</p>
      ) : rewards.length > 0 ? (
        <table className="table-auto w-full card border-spacing-2">
          <thead>
            <tr className="">
              <th className="font-normal text-left p-4">Image</th>
              <th className="font-normal text-left p-4">Name</th>
              <th className="font-normal text-left p-4">Title</th>
              <th className="font-normal text-left p-4">Type</th>
              <th className="font-normal text-left p-4"></th>
            </tr>
          </thead>
          <tbody>
            {rewards.map((reward) => (
              <tr key={reward.id}>
                <td className="p-4">
                  <img src={reward.rewardImageUrl} alt={reward.name} className="w-16 h-16 object-cover" />
                </td>
                <td className="p-4">{reward.name}</td>
                <td className="p-4">{reward.title}</td>
                <td className="p-4">{reward.rewardActionType}</td>
                <td className="p-4">
                  <PositiveButton
                    className="w-full"
                    onClick={() => {
                      navigate(`/admin/campaigns/${campaignId}/rewards/${reward.id}`);
                    }}
                  >
                    Edit
                  </PositiveButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No rewards found for this campaign.</p>
      )}
    </div>
  );
}
